import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslate } from 'hooks/translation-hooks';
import { event } from 'analytics';
import { moveToNextStep, updateCurrentStep } from 'redux/actions/stepActions';
import { getCaseStart } from 'redux/actions/caseActions';
import caseCreationActions from 'redux/actions/caseCreationActions';
import { caseErrorSelector, caseShortUrlSelector } from 'redux/selectors/case';
import {
  currentLanguageSelector,
  decisionTreeSelector,
  decisionTreeTextToHideSelector,
} from 'redux/selectors/config';
import { getStore } from 'redux/store/config';
import { configKeySelector } from 'redux/selectors/config';

const { loadDecisionTree } = caseCreationActions;

const CATEGORY = 'home';
const FOLLOW_CASE_EVENT = 'follow_my_case';
const OPEN_CASE_EVENT = 'create_case';

export const useDTOptions = () => {
  const language = useSelector(currentLanguageSelector);
  const decisionTree = useSelector(decisionTreeSelector(language));
  const decisionTreeTextToHide = useSelector(decisionTreeTextToHideSelector);
  const [dtOptions, setDtOptions] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (!decisionTree && language) {
      dispatch(loadDecisionTree());
    }
  }, [dispatch, decisionTree, language, decisionTreeTextToHide]);

  useEffect(() => {
    if (decisionTree?.length) {
      setDtOptions(
        decisionTree
          .map(dtOption => dtOption.text)
          .filter(
            dtOptionText =>
              !decisionTreeTextToHide.includes(dtOptionText.toLowerCase()),
          )
          .join(' / '),
      );
    }
  }, [decisionTree, decisionTreeTextToHide]);
  return { dtOptions };
};

export const useCaseOpening = () => {
  const dispatch = useDispatch();
  const t = useTranslate('caseOpening');
  const { should_display_follow_my_case, should_display_creation_page_button } =
    useSelector(configKeySelector);
  const [caseReference, setCaseReference] = useState('');
  const caseReferenceHandler = e => setCaseReference(e.target.value);
  const openCase = () => {
    event(OPEN_CASE_EVENT, CATEGORY);
    dispatch(moveToNextStep());
  };
  const shortURL = useSelector(caseShortUrlSelector);
  const error = useSelector(caseErrorSelector);
  const { persistor } = getStore();

  const gotToCase = () => {
    dispatch(getCaseStart({ caseReference }));
    event(FOLLOW_CASE_EVENT, CATEGORY);
  };

  useEffect(() => {
    const effect = async () => {
      persistor.flush();
      window.location = shortURL;
    };
    if (shortURL && persistor) {
      effect();
    }
  }, [shortURL, persistor]);

  useEffect(() => {
    dispatch(updateCurrentStep({}));
  }, [dispatch]);

  return {
    t,
    showCaseCreationButton: should_display_creation_page_button,
    openCase,
    showFollowMyCase: should_display_follow_my_case,
    caseReferenceHandler,
    error,
    gotToCase,
  };
};
